import styled from '@emotion/styled';
import { media, theme } from '@vfit/shared/themes';
import { IStyledAccordion, ITitleText } from './accordion.models';

export const StyledAccordion = styled.div<IStyledAccordion>`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: ${({ padding }) => padding || '1rem 0rem'};
  background: ${({ background }) => background || theme.colors.bg.primary};
  border-top: ${theme.borderWidth.thin} solid;
  border-color: ${({ borderColor }) => borderColor || theme.colors.border.default};

  ${media.withProps.desktop<IStyledAccordion>(
    ({ padding, isMenu }) => `
    padding: ${isMenu && padding ? padding : `1.844rem 0`};
  `,
  )}
`;

export const Title = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const TitleText = styled.h5<ITitleText>`
  font-family: ${({ fontFamily }) => fontFamily || theme.typography.fontFamily.primary};
  font-weight: ${({ fontWeight }) => fontWeight || theme.typography.fontWeight.regular};
  font-size: ${({ fontSize }) => fontSize || theme.typography.fontSize.body1};
  margin: 0;
  cursor: pointer;
  color: ${({ color }) => color || theme.colors.text.primary};
  line-height: ${({ lineHeight }) => lineHeight || theme.typography.lineHeight.body1};

  ${media.withProps.desktop<ITitleText>(
    ({ fontWeight, fontSize, isMenu, lineHeight }) => `
      font-weight: ${fontWeight || theme.typography.fontWeight.regular};
      font-size: ${isMenu && fontSize ? fontSize : theme.typography.fontSize.h5};
      line-height: ${isMenu && lineHeight ? lineHeight : theme.typography.fontSize.h5};
      font-style: normal;
    `,
  )}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.regular};
  font-size: ${theme.typography.fontSize.body2};
  line-height: ${theme.typography.lineHeight.body2};
`;

export const IconSpan = styled.span<{
  color?: string;
  size?: number;
}>`
  cursor: pointer;
  transform: rotate(0deg);
  transition: transform 0.5s;

  &.showing {
    transition: transform 0.5s;
    transform: rotate(-180deg);
  }

  svg {
    width: ${({ size }) => size || 24}px;
    height: auto;

    path {
      stroke: ${({ color }) => color || '#333'};
    }
  }
`;

export const SubtitleText = styled.p`
  margin-bottom: 8px;
  font-weight: ${theme.typography.fontWeight.bold};
`;

export const ContentText = styled.p`
  margin: 0;
  font-weight: ${theme.typography.fontWeight.bold};
`;

